(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nekoan-footer-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
const select = event.target;
if (!(select instanceof HTMLSelectElement) || !select.closest('.nekoan-footer-localization')) return;
if (select.form) select.form.requestSubmit();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nekoan-footer-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nekoan-footer-submit')) {
  customElements.define('nekoan-footer-submit', class extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      if (!form || form.dataset.submitBound) return;
      form.dataset.submitBound = 'true';
      form.addEventListener('submit', event => {
        if (form.dataset.submitting) { event.preventDefault(); return; }
        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
        const button = form.querySelector('button[type="submit"]');
        button.disabled = true;
        button.textContent = this.dataset.submitting;
        setTimeout(() => {
          delete form.dataset.submitting;
          form.removeAttribute('aria-busy');
          button.disabled = false;
          button.textContent = this.dataset.subscribe;
        }, 15000);
      });
      window.addEventListener('pageshow', () => {
        delete form.dataset.submitting;
        form.removeAttribute('aria-busy');
        const button = form.querySelector('button[type="submit"]');
        button.disabled = false;
        button.textContent = this.dataset.subscribe;
      }, { signal: (this.controller = new AbortController()).signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nekoan-gallery-controls"] && !Shopify.designMode) return;
  try {
    (() => {
const bind = () => {
document.querySelectorAll('[data-nekoan-manual-gallery]').forEach(gallery => {
if(gallery.dataset.nekoanProgressBound) return;
const root=gallery.closest('.nekoan-manual-gallery');
const status=root?.querySelector('[data-nekoan-gallery-status]');
if(!status)return;
gallery.dataset.nekoanProgressBound='true';
let pending=false;
let origin=null, dragged=false;
gallery.addEventListener('pointerdown',event=>{origin={x:event.clientX,y:event.clientY};dragged=false;},true);
gallery.addEventListener('pointermove',event=>{if(origin&&Math.abs(event.clientX-origin.x)>10&&Math.abs(event.clientX-origin.x)>Math.abs(event.clientY-origin.y))dragged=true;},true);
gallery.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopImmediatePropagation();dragged=false;}},true);
const update=()=>{
pending=false;
const slides=Array.from(gallery.querySelectorAll('.slick-slide:not(.slick-cloned)'));
const total=slides.length||gallery.children.length||1;
const selected=slides.findIndex(slide=>slide.classList.contains('slick-current'));
const current=Math.min(total,Math.max(1,selected+1));
status.querySelector('[data-nekoan-gallery-current]').textContent=current;
status.querySelector('[data-nekoan-gallery-total]').textContent=total;
status.setAttribute('aria-label',current+' / '+total);
};
const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(update);}};
new MutationObserver(schedule).observe(gallery,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
update();
});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();
document.addEventListener('shopify:section:load',bind);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nekoan-sized-purchase"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nekoan-sized-purchase')){
customElements.define('nekoan-sized-purchase',class extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;this.config=JSON.parse(this.querySelector('[data-config]').textContent);
if(this.config.preview){this.config.currency='USD';this.config.clothing=this.config.clothing.map((v,i)=>({...v,available:true,price:8990+i*400}));this.config.hat=[{id:56164137075030,available:true,price:2990},{id:56164137107798,available:true,price:2990},{id:56164137140566,available:true,price:2990}];}
this.mode=this.querySelector('[data-purchase]');this.clothing=this.querySelector('[data-clothing]');this.hat=this.querySelector('[data-hat]');this.quantity=this.querySelector('[data-quantity]');this.button=this.querySelector('[data-add]');this.error=this.querySelector('[data-error]');
this.addEventListener('change',()=>this.update());this.quantity.addEventListener('input',()=>this.update());this.button.addEventListener('click',()=>this.addItems());this.update();
}
selection(){
const mode=this.mode.value,quantity=Number(this.quantity.value),clothing=this.config.clothing.find(v=>String(v.id)===this.clothing.value),hat=this.config.hat.find(v=>String(v.id)===this.hat.value);
const selected=mode==='both'?[clothing,hat]:mode==='hat'?[hat]:[clothing],ready=Number.isInteger(quantity)&&quantity>0&&quantity<=5&&selected.every(v=>v&&v.available);
return {mode,quantity,selected,ready,items:ready?selected.map(v=>({id:v.id,quantity})):[]};
}
update(){
const s=this.selection();this.querySelector('[data-clothing-field]').hidden=s.mode==='hat';this.querySelector('[data-hat-field]').hidden=s.mode==='clothing';this.querySelector('[data-saving]').hidden=s.mode!=='both';
const complete=s.selected.every(Boolean),usd=this.config.currency==='USD';let amount=s.selected.reduce((n,v)=>n+(v?.price||0),0)*s.quantity;if(s.mode==='both'&&complete&&usd)amount-=1000*s.quantity;
this.querySelector('[data-price-label]').textContent=s.mode==='both'&&!usd?this.config.labels.subtotal:this.config.labels.total;
this.querySelector('[data-price]').textContent=complete&&Number.isFinite(amount)?new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.config.currency||'USD'}).format(amount/100):'—';this.button.disabled=!s.ready;
}
async addItems(){
const s=this.selection();if(!s.ready)return;this.error.hidden=true;this.button.disabled=true;this.button.textContent=this.config.labels.adding;
try{const response=await fetch(this.config.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:s.items})});const result=await response.json();if(!response.ok)throw new Error(result.description||this.config.labels.error);window.location.assign(this.config.cart);}
catch(error){this.error.textContent=error.message||this.config.labels.error;this.error.hidden=false;this.button.textContent=this.config.labels.add;this.update();}
}
});}
  } catch(e) { console.error(e); }
})();

})();
